The stream date & time that resulting events must succeed.

This can be used to initiate the retrieval of paginated results.
Subsequent queries should use the opaque cursors returned from `EventsConnection`.
